import React, { Component } from 'react';

import TOOLS from '../../componentes/TOOLS';

import '../css/EditAppUploader.css';

class EditAppUploader extends Component {
    constructor(props) {
        super();
        this.file = null;
        this.state = {
            message: "Imagem não selecionada!",
            src: ""
        };
    }

    upload() {
        if (!this.props.appId) {
            alert("É preciso informar o App Id");
            return;
        }


        const form = new FormData()
        let fileServerName = "";
        switch (this.props.typeUpload) {
            case "icon":
                fileServerName = `${this.props.appId}-icon.jpg`
                break;
            case "squareBanner":
                fileServerName = `${this.props.appId}-${this.props.lang}-squareBanner.jpg`
                break;
            case "wideBanner":
                fileServerName = `${this.props.appId}-${this.props.lang}-wideBanner.jpg`
                break;
            case "print":
                fileServerName = `${this.props.appId}-${this.props.lang}-print${Date.now()}.jpg`
                break;
            default:
                fileServerName = `${this.props.appId}-icon.jpg`
                break;

        }
        form.append('fileServerName', fileServerName);
        form.append('file', this.file, "temp.jpg");

        let resquestOptions = {
            method: "POST",
            body: form
        };

        fetch(`${TOOLS.serverURL}/upload/`, resquestOptions)
            .then(response => response.json())
            .then(uploadResponse => {
                if (uploadResponse.ok) {
                    this.setState({ message: `Sucesso! ${uploadResponse.url}`, src: "" });
                    this.props.callBackUploadSuccess(uploadResponse.url);
                }
                return uploadResponse.imgUrl;
            });
    }

    handleChange(e) {
        e.preventDefault();
        let reader = new FileReader();
        this.file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({ message: "Imagem Selecionada! Pronta para fazer upload.", src: reader.result });
        }

        reader.readAsDataURL(this.file);
    }

    handleClick(e) {
        e.preventDefault();

        if (!this.file) {
            alert("Nehuma Arquivo Selecinado");
            return;
        }

        this.setState({ message: "Upload em processo..." });
        this.upload();
    }

    render() {
        return (
            <div className="editAppUploader" >
                <input type="file" onChange={this.handleChange.bind(this)} />
                <div className="form-container">
                    <button type="button" className="btn btn-default" onClick={this.handleClick.bind(this)} >Uplaod</button>
                    <div>{this.state.message}</div>
                    <img className={this.props.cssTag} src={this.state.src} alt="Alt" />
                </div>
            </div>
        );
    }
}

export default EditAppUploader;



// WEBPACK FOOTER //
// ./src/adm/componentes/EditAppUploader.js